function timeDifference(current, previous) {
  const miliSecondsPerMinute = 60 * 1000;
  const miliSecondsPerHour = miliSecondsPerMinute * 60;
  const miliSecondsPerDay = miliSecondsPerHour * 24;
  const miliSecondsPerMonth = miliSecondsPerDay * 30;
  const miliSecondsPerYear = miliSecondsPerDay * 365;

  const elapsed = current - previous;

  if (elapsed < miliSecondsPerMinute / 3) return 'hace poco';
  if (elapsed < miliSecondsPerMinute) return ' hace 1 minuto';
  else if (elapsed < miliSecondsPerHour)
    return 'hace ' + Math.round(elapsed / miliSecondsPerMinute) + ' minutos';
  else if (elapsed < miliSecondsPerDay)
    return 'hace ' + Math.round(elapsed / miliSecondsPerHour) + ' horas';
  else if (elapsed < miliSecondsPerMonth)
    return 'hace ' + Math.round(elapsed / miliSecondsPerDay) + ' días';
  else if (elapsed < miliSecondsPerYear)
    return 'hace ' + Math.round(elapsed / miliSecondsPerMonth) + ' meses';
  else return 'hace ' + Math.round(elapsed / miliSecondsPerYear) + ' años';
}

export function timeDifferenceForDate(date) {
  const ahora = new Date().getTime();
  const actualizado = new Date(parseInt(date)).getTime();
  // console.log(
  //   'Date: ' + date,
  //   'Ahora: ' + ahora,
  //   'Actualizado: ' + actualizado
  // );
  return timeDifference(ahora, actualizado);
}
